import instantsearch from 'instantsearch.js';
import {
    clearRefinements,
    configure,
    currentRefinements,
    hits,
    pagination,
    refinementList,
    toggleRefinement,
} from 'instantsearch.js/es/widgets';

import { getAlgoliaSearchClient, normalizeFilterItems, normalizeRefinements } from './algolia-helpers';
import './furniture-comparison';
import { furnitureRouting } from './furniture-routing';

if (document.getElementById('furniture-hits')) {
    const searchClient = getAlgoliaSearchClient();
    const indexName = `${window.algolia.prefix}_mckinnon_furniture`;
    const search = instantsearch({
        indexName,
        searchClient,
        searchParameters: {
            disjunctiveFacetsRefinements: {
                product: [true],
            },
            hitsPerPage: 36,
            filters: 'status:live OR status:enabled',
        },
        routing: furnitureRouting,
        searchFunction(helper) {
            const page = helper.getPage();
            const { disjunctiveFacetsRefinements } = helper.state;

            if (disjunctiveFacetsRefinements.new) {
                helper.setIndex(`${window.algolia.prefix}_mckinnon_furniture_new`);
            } else if (disjunctiveFacetsRefinements.collection || disjunctiveFacetsRefinements.categories) {
                helper.setIndex(`${window.algolia.prefix}_mckinnon_furniture_filtered`);
            } else {
                helper.setIndex(`${window.algolia.prefix}_mckinnon_furniture`);
            }

            if (helper.state.disjunctiveFacetsRefinements) {
                helper.state.disjunctiveFacetsRefinements = normalizeRefinements(
                    helper.state.disjunctiveFacetsRefinements
                );
            }

            helper.setPage(page);
            helper.search();
        },
    });

    search.addWidgets([
        configure({
            analytics: true,
            clickAnalytics: true,
        }),

        clearRefinements({
            container: '#clear-refinements',
            excludedAttributes: ['product'],
            templates: {
                resetLabel: 'Clear Filters',
            },
            cssClasses: {
                button: ['button', 'clear-filters'],
                disabledButton: ['hidden-button'],
            },
        }),

        clearRefinements({
            container: '#clear-refinements-second',
            excludedAttributes: ['product'],
            templates: {
                resetLabel: 'Clear Filters',
            },
            cssClasses: {
                button: ['clear-filters', 'js-clear-filters'],
                disabledButton: ['hidden-button'],
            },
        }),

        currentRefinements({
            container: '#current-refined-values',
            excludedAttributes: ['product'],
            transformItems(items) {
                return items.map(item => ({
                    ...item,
                    refinements: item.refinements.map(function(refinement) {
                        switch (refinement.attribute) {
                            case 'quickShip':
                                refinement.label = 'Quick Ship';
                                break;
                            case 'favorites':
                                refinement.label = 'Our Favorites';
                                break;
                            case 'new':
                                refinement.label = 'New';
                                break;
                            default:
                        }

                        return refinement;
                    }),
                }));
            },
        }),

        hits({
            container: '#furniture-hits',
            templates: {
                item: `
    				<div
                        class="item category{{ typeId }} {{ childProducts }}"
                        style="position:relative;"
                        onclick="if (!window.internalIPs.includes(window.userIP)) window.aa('clickedObjectIDsAfterSearch', {
                            index: '${indexName}',
                            eventName: 'Search Result Clicked',
                            objectIDs: ['{{ objectID }}'],
                            queryID: '{{ __queryID }}',
                            positions: [{{ __position }}],
                        });"
                    >
                        <div class="field" style="width:100%;margin:0;position:absolute;top:7px;left:24px;z-index:1;">
                            <ul class="check-radio">
                                <li class="checkbox-wrapper" style="height:50px;margin:0;">
                                    <input
                                        type="checkbox"
                                        name="products"
                                        id="product-{{ id }}"
                                        value="{{ sku }}"
                                        data-title="{{ title }}"
                                        data-sku="{{ sku }}"
                                        data-image1x="{{ image1x }}"
                                        data-image2x="{{ image2x }}"
                                    />
                                    <label for="product-{{ id }}" style="padding:17px 17px 17px 0;"><span>Compare</span></label>
                                </li>
                            </ul>
                        </div>
					    <a href="{{ uri }}" target="_blank">
					        <figure>
					            <img 
					                src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" 
					                src="{{ image1x }}" 
					                srcset="
					                    {{ image1x }} 1x,
					                    {{ image2x }} 2x
					                "
					                alt=""
					            />
					        </figure>
					        <h2>{{ title }}</h2>
					    </a>
					</div><!-- /.item -->
    			`,
                empty: 'Sorry, your search returned no results.',
            },
        }),

        pagination({
            container: '#pagination',
            scrollTo: document.getElementsByClassName('module module-text')[0],
        }),

        refinementList({
            container: '#facet-categories',
            attribute: 'categories',
            limit: 100,
            sortBy: ['name:asc'],
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),

        refinementList({
            container: '#facet-collection',
            attribute: 'collection',
            limit: 100,
            sortBy(a, b) {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();
                if (a === b) return 0;
                return a < b ? -1 : 1;
            },
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),

        toggleRefinement({
            container: '#facet-quick-ship',
            attribute: 'quickShip',
            on: 1,
            templates: {
                labelText: `Quick Ship`,
            },
        }),

        toggleRefinement({
            container: '#facet-favorites',
            attribute: 'favorites',
            on: 1,
            templates: {
                labelText: `Our Favorites`,
            },
        }),

        toggleRefinement({
            container: '#facet-new',
            attribute: 'new',
            on: 1,
            templates: {
                labelText: `New`,
            },
        }),
    ]);

    search.start();

    search.helper.on('result', function(data) {
        if (data.nbHits < 36) {
            document.getElementById('pagination').style.display = 'none';
        } else {
            document.getElementById('pagination').style.display = 'block';
        }

        document.getElementById('facet-categories-header').style.display = 'none';
        document.getElementById('facet-collection-header').style.display = 'none';
        data.disjunctiveFacets.forEach(function(facet) {
            if (facet.name === 'categories') {
                document.getElementById('facet-categories-header').style.display = 'block';
            } else if (facet.name === 'collection') {
                document.getElementById('facet-collection-header').style.display = 'block';
            }
        });

        let showNew = false;
        let showFavorites = false;
        let showQuickShip = false;

        /* eslint-disable-next-line */
        for (const key in search.helper.state.disjunctiveFacetsRefinements) {
            if (key === 'new') {
                document
                    .getElementById('facet-new')
                    .getElementsByTagName('span')[0]
                    .classList.add('active-facet');
                showNew = true;
            } else if (key === 'favorites') {
                document
                    .getElementById('facet-favorites')
                    .getElementsByTagName('span')[0]
                    .classList.add('active-facet');
                showFavorites = true;
            } else if (key === 'quickShip') {
                document
                    .getElementById('facet-quick-ship')
                    .getElementsByTagName('span')[0]
                    .classList.add('active-facet');
                showQuickShip = true;
            }
        }

        if (showNew === false) {
            document
                .getElementById('facet-new')
                .getElementsByTagName('span')[0]
                .classList.remove('active-facet');
        }

        if (showFavorites === false) {
            document
                .getElementById('facet-favorites')
                .getElementsByTagName('span')[0]
                .classList.remove('active-facet');
        }

        if (showQuickShip === false) {
            document
                .getElementById('facet-quick-ship')
                .getElementsByTagName('span')[0]
                .classList.remove('active-facet');
        }
    });
}
